/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PasswordProtectionQuery
 */
export interface PasswordProtectionQuery {
    /**
     * 
     * @type {string}
     * @memberof PasswordProtectionQuery
     */
    password: string;
}

/**
 * Check if a given object implements the PasswordProtectionQuery interface.
 */
export function instanceOfPasswordProtectionQuery(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "password" in value;

    return isInstance;
}

export function PasswordProtectionQueryFromJSON(json: any): PasswordProtectionQuery {
    return PasswordProtectionQueryFromJSONTyped(json, false);
}

export function PasswordProtectionQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordProtectionQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'password': json['Password'],
    };
}

export function PasswordProtectionQueryToJSON(value?: PasswordProtectionQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Password': value.password,
    };
}

